// extracted by mini-css-extract-plugin
module.exports = {"report":"reportSideBar__report","report-wrapper":"reportSideBar__report-wrapper","report-item":"reportSideBar__report-item"};